module.exports = {
      id: "icon-user-usage",
      viewBox: "0 0 50 50",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-user",
      toString: function () {
        return this.url;
      }
    }